import {action, makeAutoObservable} from "mobx";
import MoneySalePrice from "../../../entities/productOrder/moneyDelivery/MoneySalePrice";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";


class RemoveMoneySalePriceStore {

    public salePriceId: string;
    public moneySalePrice: MoneySalePrice;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, salePriceId: string, moneySalePrice: MoneySalePrice) {
        this.salePriceId = salePriceId;
        this.moneySalePrice = moneySalePrice;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async remove() {
        const response = await SalePriceService.deleteMoneySalePriceValues(this.salePriceId, this.moneySalePrice.id);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default RemoveMoneySalePriceStore;